import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import "@ui5/webcomponents/dist/Assets.js";
import "@ui5/webcomponents-fiori/dist/Assets.js";
import "@ui5/webcomponents-localization/dist/Assets.js";
import "@ui5/webcomponents-react/dist/Assets.js";
import "@ui5/webcomponents-icons/dist/AllIcons.js";
import { ThemeProvider } from '@ui5/webcomponents-react';
import { fetchCldr } from "@ui5/webcomponents-base/dist/asset-registries/LocaleData.js";
import { initializeTheme } from './utils/theme';

(async () => {
  // Pre-carga CLDR sincrónicamente antes de que cualquier componente renderice.
  // Necesario para que DatePicker pueda resolver el calendario gregoriano.
  await Promise.all([
    fetchCldr("en", "", ""),
    fetchCldr("es", "", ""),
  ]);

  initializeTheme();

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </React.StrictMode>
  );
})();
